import { useId, useState } from 'react';
import { useTravelText } from '../app/TravelLocaleContext';

/** Password input with show/hide toggle. */
export default function PasswordField({
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  autoComplete = 'current-password',
  minLength,
  maxLength,
  id: idProp,
}) {
  const generatedId = useId();
  const inputId = idProp || generatedId;
  const [visible, setVisible] = useState(false);
  const { t } = useTravelText();

  return (
    <div className="travel-auth__field">
      <label htmlFor={inputId}>{label}</label>
      <div className="travel-auth__password">
        <input
          id={inputId}
          required={required}
          type={visible ? 'text' : 'password'}
          autoComplete={autoComplete}
          value={value}
          minLength={minLength}
          maxLength={maxLength}
          onChange={onChange}
          disabled={disabled}
        />
        <button
          type="button"
          className="travel-auth__password-toggle"
          aria-label={t(visible ? 'travel.auth.password.hide' : 'travel.auth.password.show')}
          aria-pressed={visible}
          onClick={() => setVisible((current) => !current)}
          disabled={disabled}
        >
          {visible ? (
            <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
              <path
                fill="currentColor"
                d="M3.1 2.3 2 3.4l3.1 3.1C3.2 8 1.8 9.8 1 12c1.7 3.9 6 7 11 7 1.7 0 3.3-.4 4.7-1l3.2 3.2 1.1-1.1L3.1 2.3zM12 17c-3.9 0-7.2-2.3-8.7-5 .7-1.4 1.8-2.7 3.1-3.6l1.7 1.7A4 4 0 0 0 12 16c.5 0 1-.1 1.4-.3l1.5 1.5c-.9.5-1.9.8-2.9.8zm0-10c.4 0 .8 0 1.2.1l-1.6 1.6A3 3 0 0 0 9 12c0 .3 0 .5.1.8L7.5 14.4A5 5 0 0 1 12 7zm9.9-1.7-1.5 1.5C21.6 8.4 22.5 10.1 23 12c-1.7 3.9-6 7-11 7-.8 0-1.5-.1-2.2-.2l1.6-1.6c.2 0 .4.1.6.1 3.9 0 7.2-2.3 8.7-5-.5-1-1.2-2-2.1-2.8l1.5-1.5 1.8-1.8z"
              />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
              <path
                fill="currentColor"
                d="M12 5C7 5 2.7 8.1 1 12c1.7 3.9 6 7 11 7s9.3-3.1 11-7c-1.7-3.9-6-7-11-7zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2.5A2.5 2.5 0 1 0 12 9.5a2.5 2.5 0 0 0 0 5z"
              />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}
